import { Col, Container, Row } from "react-bootstrap";

import { Fragment, useState } from "react";

import Banner from "../components/Banner/Banner";
import useWindowScrollToTop from "../hooks/useWindowScrollToTop";

import PrivacyPolicy from "../components/SpecialOffer/PrivacyPolicy";


const PrivacyPolicyPage = () => {

  useWindowScrollToTop();

  return (
    <Fragment>
      <Banner title="Privacy Policy" />
   
        <Container className="filter-bar-contianer">
          
        </Container>
        <Container>
         <PrivacyPolicy/>
        
        </Container>
 
    </Fragment>
  );
};

export default PrivacyPolicyPage;
